import { FormContainer } from 'react-hook-form-mui';
import {
    AiSmartReplyPlan,
    EditAiSmartReplyPlanRequest,
    buildEditAiSmartReplyPlanRequest,
} from '../../../../../sic-lib/api/ai/types/Ai';
import { useAiUpdateSmartReplyPlan } from '../../../../../sic-lib/api/hooks/useAiSmartReply';
import { DrawerCommon } from '../../../../Shared/Drawer/DrawerCommon';
import { EditSmartReplyPlanFormControls } from './EditSmartReplyPlanFormControls';

interface Props {
    isOpen: boolean;
    handleClose: () => void;
    plan: AiSmartReplyPlan;
}

export function EditSmartReplyPlanDrawer({ isOpen, handleClose, plan }: Props) {
    const {
        mutateAsync: updatePlan,
        isPending: isLoading,
        isError,
        isSuccess,
        error,
    } = useAiUpdateSmartReplyPlan();

    const handleUpdate = async (formValues: EditAiSmartReplyPlanRequest) => {
        await updatePlan(buildEditAiSmartReplyPlanRequest(formValues));
    };

    return (
        <DrawerCommon
            title="Edit SmartReply Plan"
            open={isOpen}
            handleOnClose={handleClose}
            width="800px"
        >
            <FormContainer<EditAiSmartReplyPlanRequest>
                defaultValues={{ ...plan }}
                mode="all"
                onSuccess={handleUpdate}
            >
                <EditSmartReplyPlanFormControls
                    isLoading={isLoading}
                    isError={isError}
                    isSuccess={isSuccess}
                    error={error}
                    plan={plan}
                />
            </FormContainer>
        </DrawerCommon>
    );
}
